define('ItemSegmentation.Utils', [
    'SC.Configuration',
    'underscore'
], function ItemSegmentationUtils(
    Configuration,
    _
) {
    'use strict';

    function normalizeDomainList(domains) {
        var normalizedDomains = String(domains || '')
            .replace(/(?:&amp;|&)(?:nbsp|#160);/gi, '')
            .replace(/\u00a0/g, '');

        return _.chain(normalizedDomains.split(','))
            .map(function normalizeDomain(domain) {
                return String(domain || '')
                    .replace(/^https?:\/\//i, '')
                    .split('/')[0]
                    .replace(/^\s+|\s+$/g, '')
                    .toLowerCase();
            })
            .filter(function removeEmptyDomain(domain) {
                return !!domain;
            })
            .value();
    }

    function getStorefrontDomains() {
        var hostname = String(
            (SC.ENVIRONMENT && SC.ENVIRONMENT.currentHostString) ||
            window.location.hostname ||
            ''
        ).toLowerCase();
        var domains = [hostname];

        if (hostname === 'buyflu-sandbox.ethanablatt.com') {
            domains.push('buyflushots.nmsincusa.com');
        } else if (hostname === 'sca-sandbox.ethanablatt.com') {
            domains.push('nmsincusa.com');
        }

        return _.uniq(_.compact(domains));
    }

    function isDomainVisible(domains, storefrontDomains) {
        var normalizedDomains = normalizeDomainList(domains);
        var acceptedDomains = storefrontDomains || getStorefrontDomains();

        return !normalizedDomains.length || _.some(acceptedDomains, function domainMatches(site) {
            return normalizedDomains.indexOf(String(site || '').toLowerCase()) !== -1;
        });
    }

    function getStorefrontDomain() {
        return getStorefrontDomains()[0] || window.location.host;
    }

    function getSearchApiDomain() {
        return getStorefrontDomain().replace(/-/g, '~');
    }

    return {
        filterData: function filterData(data, customerCategory) {
            var sites = getStorefrontDomains();
            var itemCustomerCategories;
            var customerCategoryFilter = customerCategory ? this.getCustomerCategoryFacetFilter(customerCategory.value) : '';

            data.items = _.filter(data.items || [], function filterItems(f) {
                var hasValidCustomerCategories;
                itemCustomerCategories = f.custitem_awa_customer_category && f.custitem_awa_customer_category !== '&nbsp;' ?
                    f.custitem_awa_customer_category.split(', ') : [];
                hasValidCustomerCategories = customerCategoryFilter ? _.any(itemCustomerCategories,
                    function anyCustomCategoryMatchesUserCategory(itemCustomCategory) {
                        return itemCustomCategory === customerCategoryFilter.text;
                    }) : true;

                if (f.correlateditems_detail && f.correlateditems_detail.length) {
                    f.correlateditems_detail = _.filter(f.correlateditems_detail || [], function filterCorrelated(cr) {
                        return isDomainVisible(cr.custitem_awa_domains, sites) && hasValidCustomerCategories;
                    });
                }
                if (f.relateditems_detail && f.relateditems_detail.length) {
                    f.relateditems_detail = _.filter(f.relateditems_detail || [], function filterRelated(r) {
                        return isDomainVisible(r.custitem_awa_domains, sites) && hasValidCustomerCategories;
                    });
                }

                if (f.custitem_awa_domains && f.custitem_awa_customer_category) {
                    return isDomainVisible(f.custitem_awa_domains, sites) && hasValidCustomerCategories;
                }

                return true;
            });

            return data;
        },

        extendCollection: function extendCollection(collectionName, customerCategory) {
            var collection;
            var self = this;
            try {
            // eslint-disable-next-line global-require
                collection = require(collectionName);
                if (collection && collection.prototype && collection.prototype.parse) {
                    collection.prototype.parse = _.wrap(collection.prototype.parse, function wrapFn(fn, responseData) {
                        var retFilter = self.filterData(responseData, customerCategory, collectionName);
                        return fn.apply(this, [retFilter]);
                    });
                // Recently viewed is a quirky singleton
                } else if (collection && collection.getInstance && collection.getInstance()) {
                    collection.getInstance().parse = _.wrap(collection.getInstance().parse, function wrapFnRecently(fn, responseData) {
                        var retFilter = self.filterData(responseData, customerCategory, collectionName);
                        return fn.apply(this, [retFilter]);
                    });
                }
            } catch (e) {
                console.error(e);
            }
        },

        addToSearchAPIMasterOptions: function addToSearchAPIMasterOptions(apiOptions, customerCategory) {
            var customerCategoryFacetFilter = customerCategory ? this.getCustomerCategoryFacetFilter(customerCategory.value) : '';

            _.each(apiOptions, function eachApiOptions(value) {
                if (String(value.fieldset) !== 'details') {
                    value.custitem_awa_domains = getSearchApiDomain();
                }

                if (customerCategoryFacetFilter && customerCategoryFacetFilter.urlComponent) {
                    value.custitem_awa_customer_category = customerCategoryFacetFilter.urlComponent;
                    value.use_pcv = 'F';
                }
            });

            return apiOptions;
        },

        getCustomerCategoryFacetFilter: function getCustomerCategoryFacetValue(customerCategoryValue) {
            var customerCategoryFacetFilter = _.findWhere(Configuration.get('itemsegmentation.customercategories'), { value: customerCategoryValue });

            return customerCategoryFacetFilter;
        },

        getStorefrontDomains: getStorefrontDomains,
        isDomainVisible: isDomainVisible
    };
});
